import { Injectable, inject } from '@angular/core'
import { Integration, IntegrationCreateResponse } from '../types/integrations'
import { HttpClient } from '@angular/common/http'
import { Observable, catchError, map } from 'rxjs'
import { environment } from '../../environments/environment'
import { ErrorService } from './error.service'

@Injectable({
  providedIn: 'root',
})
export class IntegrationService {
  private URL = environment.baseUrl + 'integrations'
  http = inject(HttpClient)
  errorService = inject(ErrorService)

  /**
   * Sends request to create an Integration Session
   * @returns {Observable<string>} The api key generated
   */
  create(): Observable<string> {
    return this.http.post<IntegrationCreateResponse>(this.URL, {}).pipe(
      map((res) => res.apiKey),
      catchError(this.errorService.handleError),
    )
  }

  /**
   * Gets all active Integration Sessions
   * @returns {Observable<Array<Integration>>} The active Integration sessions found
   */
  getAll(): Observable<Array<Integration>> {
    return this.http
      .get<Array<Integration>>(this.URL)
      .pipe(catchError(this.errorService.handleError))
  }
}
